module.exports = __webpack_public_path__ + "static/lights18-4cc663a6b77adefa5360b79292fb1619.jpg";